export async function method(params, actions) {
  const methodName = params.property?.methodName
  if (!methodName) {
    return Promise.reject('未配置methodName属性')
  }
  if (typeof methodName === 'string' && !actions[methodName]) {
    return Promise.reject(`未找到【${methodName}】方法`)
  }
  return typeof methodName === 'string'
    ? actions[methodName](params.parameter, actions)
    : methodName(params.parameter, actions)
}
